import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import {
  EmptyStateSize,
  EmptyStateType
} from './m-empty-states.component.types';

@Component({
  selector: 'm-empty-states',
  templateUrl: './m-empty-states.component.html'
})
export class MEmptyStatesComponent implements OnInit, OnChanges {
  private readonly baseUrl = 'https://assets.measured.com/shared/';

  private readonly emptyStateImageMap: Record<EmptyStateType, string> = {
    [EmptyStateType.nothingToShow]: 'nothing-to-show.svg',
    [EmptyStateType.dataProcessing]: 'data-processing.svg',
    [EmptyStateType.dataNotAvailableError]: 'error.svg',
    [EmptyStateType.actionRequired]: 'action-required.svg',
    [EmptyStateType.pageNotFound]: '404.svg',
    [EmptyStateType.success]: 'success.svg',
    [EmptyStateType.ufoLoader]: 'ufo-loader.svg'
  };

  @Input() size: EmptyStateSize = EmptyStateSize.medium;
  @Input() title = 'Empty State';
  @Input() description = 'We don&quot;t have any data to show here';
  @Input() stateType: EmptyStateType = EmptyStateType.nothingToShow;
  @Input() imageClass = '';

  creative = 'nothing-to-show.svg';

  ngOnInit() {
    this.creative = `${this.baseUrl}${this.emptyStateImageMap[this.stateType] || this.creative}`;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['stateType']) {
      this.creative = `${this.baseUrl}${this.emptyStateImageMap[this.stateType] || this.creative}`;
    }
  }

  get imageWidth() {
    return this.getSizeImageWidth();
  }

  get titleClass() {
    return this.getSizeTitleClass();
  }

  get descriptionClass() {
    return this.getSizeDescriptionClass();
  }

  private getSizeImageWidth(): number {
    switch (this.size) {
      case EmptyStateSize.tiny:
        return 80;
      case EmptyStateSize.small:
        return 160;
      case EmptyStateSize.medium:
        return 310;
      case EmptyStateSize.intermediate:
        return 512;
      case EmptyStateSize.large:
        return 600;
      default:
        return 310;
    }
  }

  private getSizeTitleClass(): string {
    switch (this.size) {
      case EmptyStateSize.tiny:
        return 'sh2';
      case EmptyStateSize.small:
        return 'h5';
      case EmptyStateSize.medium:
        return 'h4';
      case EmptyStateSize.intermediate:
        return 'dp2';
      case EmptyStateSize.large:
        return 'dp1';
      default:
        return 'h4';
    }
  }

  private getSizeDescriptionClass(): string {
    switch (this.size) {
      case EmptyStateSize.tiny:
        return 'c2';
      case EmptyStateSize.small:
        return 'b1';
      case EmptyStateSize.medium:
        return 'sh1';
      case EmptyStateSize.intermediate:
        return 'b2';
      case EmptyStateSize.large:
        return 'dp2';
      default:
        return 'sh1';
    }
  }
}
